import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { device, fontSize, fontWeight, space } from '@ticketswap/solar'
import { ChevronLeft, Facebook, Instagram, Dots } from '@ticketswap/comets'
import Link from 'next/link'
import { getLinkProps } from '~/utils'

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: ${space[8]};

  @media ${device.tablet} {
    margin-bottom: ${space[16]};
  }
`

const BackLink = styled.a`
  background-color: #28383d;
  border-radius: ${space[16]};
  color: white;
  font-size: ${fontSize[14]};
  line-height: 0.5;
  margin-right: ${space[12]};
  margin-top: ${space[8]};
  padding: ${space[4]} ${space[12]};
  font-weight: ${fontWeight.semiBold};

  span:last-of-type {
    position: relative;
    top: 1px;
    margin-left: ${space[4]};
  }

  @media ${device.tablet} {
    font-size: ${fontSize[16]};
    margin-right: ${space[16]};
    padding: ${space[8]} ${space[12]};
  }
`

const Links = styled.div`
  display: flex;

  a:first-of-type {
    margin-right: ${space[8]};
  }
`

const SocialLink = styled.a`
  background-color: #28383d;
  border-radius: 50%;
  color: white;
  height: fit-content;
  line-height: 0.5;
  padding: ${space[4]};
  width: fit-content;

  @media ${device.tablet} {
    padding: ${space[8]};
  }
`

const MoreInfo = styled.button`
  background-color: #28383d;
  border-radius: 50%;
  color: white;
  height: fit-content;
  line-height: 0.5;
  padding: ${space[4]};
  width: fit-content;
  font-size: 16px;
  font-weight: ${fontWeight.semiBold};
  margin-left: ${space[8]};
  display: flex;
  justify-content: center;
  align-items: center;

  @media ${device.tablet} {
    padding: ${space[8]};
    border-radius: ${space[64]};

    span:last-of-type {
      margin-left: ${space[8]};
    }
  }
`

const MoreInfoLabel = styled.span`
  display: none;

  @media ${device.tablet} {
    display: inline;
  }
`

const EventLinks = ({
  facebookUrl,
  instagramUrl,
  getPreviousPageLink,
  backBtnText,
  onClickMoreInfo,
  showMoreInfoButton,
  t,
}) => (
  <Wrapper>
    <>
      {Boolean(getPreviousPageLink) && (
        <Link
          {...getLinkProps(
            getPreviousPageLink.backRoute,
            getPreviousPageLink.params
          )}
          passHref
        >
          <BackLink>
            <ChevronLeft size={16} />
            <span>{backBtnText}</span>
          </BackLink>
        </Link>
      )}
    </>

    <>
      {(facebookUrl || instagramUrl || showMoreInfoButton) && (
        <Links>
          {facebookUrl && (
            <SocialLink
              href={facebookUrl.facebookUrl}
              rel="noopener noreferrer"
              target="_blank"
            >
              <Facebook size={16} />
            </SocialLink>
          )}
          {instagramUrl && (
            <SocialLink
              href={`https://www.instagram.com/${instagramUrl}/`}
              rel="noopener noreferrer"
              target="_blank"
            >
              <Instagram size={16} />
            </SocialLink>
          )}

          {showMoreInfoButton && (
            <MoreInfo onClick={onClickMoreInfo}>
              <Dots size={16} />
              <MoreInfoLabel>
                {facebookUrl || instagramUrl
                  ? t('event-eventtype:header.actions.more')
                  : t('event-eventtype:header.actions.report')}
              </MoreInfoLabel>
            </MoreInfo>
          )}
        </Links>
      )}
    </>
  </Wrapper>
)

EventLinks.propTypes = {
  facebookUrl: PropTypes.object,
  instagramUrl: PropTypes.string,
  getPreviousPageLink: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  backBtnText: PropTypes.string,
  t: PropTypes.func.isRequired,
  onClickMoreInfo: PropTypes.func.isRequired,
  showMoreInfoButton: PropTypes.bool.isRequired,
}

export default EventLinks
